 window.onload = function() {
  var pageTitle = document.title;
  var attentionMessage = '¿Sigues ahí?';

  document.addEventListener('visibilitychange', function(e) {
    var isPageActive = !document.hidden;

    if(!isPageActive){

      var intervalChange = window.setInterval(function(){
   document.title = attentionMessage;
}, 2000);

            var intervalBack = window.setInterval(function(){
   document.title = pageTitle;
}, 4000);

      document.addEventListener('visibilitychange', function(e) {
      clearInterval(intervalChange);
      clearInterval(intervalBack);  
       });
     
    }else {
       clearInterval(intervalChange);
      clearInterval(intervalBack); 
      document.title = pageTitle;
    }
  });
};
  